export const MOBILE_GALLERY_IMAGE_ACCEPT =
    'image/jpeg,image/jpg,image/png,image/pjpeg,image/heic,image/heif,.jpg,.jpeg,.png,.heic,.heif';

export const GALLERY_IMAGE_ACCEPT_EXTENSIONS_ONLY = '.jpg,.jpeg,.png,.heic,.heif';

export function isIOSDevice(): boolean {
    if (typeof navigator === 'undefined') {
        return false;
    }
    const ua = navigator.userAgent || '';
    if (/iPhone|iPad|iPod/i.test(ua)) {
        return true;
    }
    return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

export function getGalleryFileAccept(): string {
    return isIOSDevice() ? GALLERY_IMAGE_ACCEPT_EXTENSIONS_ONLY : MOBILE_GALLERY_IMAGE_ACCEPT;
}
